// Search & share metadata for the app's public pages (one place).
// Everything not listed here is signed-in app space and is marked noindex.
export const APP_ORIGIN = 'https://awholefamilymatter.app';

const LEGAL = {
  '/privacy': 'Privacy Policy',
  '/terms': 'Terms of Service',
  '/care-team-guidelines': 'Care Team Guidelines',
  '/cookie-policy': 'Cookie Policy',
  '/recording-consent': 'Recording Consent',
  '/platform-disclaimer': 'Platform Disclaimer',
  '/testing-agreement': 'Testing Agreement',
  '/consumer-health-data': 'Consumer Health Data Notice',
  '/care-fund-terms': 'Care Fund Terms',
  '/advocacy-terms': 'Advocacy Terms',
};

const DEFAULT_DESC =
  'Interdependent care planning for medical migrants and their collectivist families: plan together, fund each other’s care, and learn to speak up — as one care team, across borders.';

export const SEO = {
  '/': { title: 'AWFM - Collective Work App', description: DEFAULT_DESC },
  '/welcome': { title: 'AWFM - Collective Work App', description: DEFAULT_DESC, canonical: '/' },
  '/sponsor-a-care-team': {
    title: 'Sponsor a care team · A Whole Family Matter',
    description: '€30 opens a family’s whole care plan, once. Your gift covers their fee — it never becomes cash, and nothing about the family flows back to you.',
  },
  '/sponsor-a-care-team/families': {
    title: 'Sponsor a family · A Whole Family Matter',
    description: 'Sponsor one family’s care plan: €30, paid once, for their whole care team.',
  },
  '/sponsor-a-care-team/organizations': {
    title: 'Sponsor care teams as an organization · A Whole Family Matter',
    description: 'Associations, diaspora networks and congregations can sponsor a block of families in one transaction — one charge, one receipt.',
  },
  '/community': {
    title: 'Free Community · A Whole Family Matter',
    description: 'Join the free A Whole Family Matter community for families caring across borders.',
  },
  '/after-a-death': {
    title: 'What to do after a death · A Whole Family Matter',
    description: 'A free checklist for families: papers, the wake, bringing someone home from abroad, benefits and remembrance, by faith, heritage and country. No account needed.',
  },
  '/help': {
    title: 'Help & Support · A Whole Family Matter',
    description: 'Answers about care teams, care planning, care funds, sponsorship, privacy and your account.',
  },
  '/legal': {
    title: 'Privacy & Legal Center · A Whole Family Matter',
    description: 'Our privacy policy, terms, cookie policy and every legal document, in one place.',
  },
  '/login': { title: 'Log in · A Whole Family Matter', description: 'Log in to plan, fund and advocate with your care team.' },
  '/register': {
    title: 'Get started free · A Whole Family Matter',
    description: 'Create your free account and start care planning with your family — questions 1 to 9 are free.',
  },
  ...Object.fromEntries(
    Object.entries(LEGAL).map(([path, name]) => [
      path,
      { title: `${name} · A Whole Family Matter`, description: `${name} for A Whole Family Matter.` },
    ]),
  ),
};
